// SKU lookup_keys — mirror of /app/backend/app/config.py canonical catalog.
// Frontend must NEVER hardcode prices; this maps tier/module → lookup_key only.

export const ACCESS_SKUS = {
    foundation: {
        FULL:   "AGENT_FOUNDATION_FULL",
        LETTER: "AGENT_FOUNDATION_LETTER",
        PHASE:  "AGENT_FOUNDATION_PHASE",
    },
    architect: {
        FULL:   "AGENT_ARCHITECT_FULL",
        LETTER: "AGENT_ARCHITECT_LETTER",
        PHASE:  "AGENT_ARCHITECT_PHASE",
    },
    system: {
        FULL:   "AGENT_SYSTEM_FULL",
        LETTER: "AGENT_SYSTEM_LETTER",
        PHASE:  "AGENT_SYSTEM_PHASE",
    },
    genesis: {
        FULL:   "AGENT_GENESIS_FULL",
        LETTER: "AGENT_GENESIS_LETTER",
        PHASE:  "AGENT_GENESIS_PHASE",
    },
};

export const MODULE_SKUS = {
    smithers_guidance:        "AGENT_SMITHERS_GUIDANCE",
    quadra_activation:        "AGENT_QUADRA_ACTIVATION",
    creator_network:          "AGENT_CREATOR_NETWORK",
    asset_workspace:          "AGENT_ASSET_WORKSPACE",
    asset_protection_base:    "AGENT_ASSET_PROTECTION_BASE",
    asset_protection_premium: "AGENT_ASSET_PROTECTION_PREMIUM",
    deployment_engine:        "AGENT_DEPLOYMENT_ENGINE",
};

// Phase pair canon
export const PHASE_PAIRS = [
    { phase: "P1", letters: ["A", "B"] },
    { phase: "P2", letters: ["C", "D"] },
    { phase: "P3", letters: ["E", "F"] },
    { phase: "P4", letters: ["G", "H"] },
];
